export default __webpack_public_path__ + "e6a531878f985bb42bd7c767a64c65de.jpg";